import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../layout/layout.vue";
Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    {
      path: "/",
      redirect: "/login"
    },
    {
      path: "/login",
      component: () => import("../login/login.vue"),
      meta: {
        title: "登录"
      }
    },
    {
      path: "/layout",
      name: "layout",
      component: Layout,
      children: [
        //门店管理 storeManage
        {
          path: "/home",
          component: () => import("../home/home.vue"),
          meta: {
            title: "首页",
            index: "home"
          }
        },
        {
          path: "/role",
          component: () => import("../pages/storeManage/role/index.vue"),
          meta: {
            title: "用户",
            index: "role"
          }
        },
        {
          path: "/memberAgreement",
          component: () => import("../pages/listingProfile/memberAgreement/index.vue"),
          meta: {
            title: "隐私协议管理",
            index: "memberAgreement"
          }
        },
        {
          path: "/memberDetail",
          component: () => import("../pages/listingProfile/memberAgreement/components/index.vue"),
          meta: {
            title: "详情",
            index: "memberDetail"
          }
        },
        {
          path: "/member",
          component: () => import("../pages/listingProfile/memberAgreement/components/memberDetail.vue"),
          meta: {
            title: "隐私详情",
            index: "member"
          }
        },
        // 员工 baseStaff
        {
          path: "/baseStaff",
          component: () =>
            import("../pages/storeManage/baseStaff/baseStaff.vue"),
          meta: {
            title: "员工",
            index: "baseStaff"
          }
        },

        {
          path: "/Availability",
          component: () =>
            import("../pages/listingProfile/Availability/index.vue"),
          meta: {
            title: "房源",
            index: "Availability"
          }
        },
        {
          path: "/Community",
          component: () =>
            import("../pages/listingProfile/Community/index.vue"),
          meta: {
            title: "项目",
            index: "Community"
          }
        },
        {
          path: "/availabilityManage",
          name: "availabilityManage",
          component: () =>
            import("../pages/listingProfile/availabilityManage/index.vue"),
          meta: {
            title: "房源管理",
            index: "Availability",
          }
        },
        {
          path: "/checkIn",
          component: () =>
            import("../pages/listingProfile/checkIn/index.vue"),
          meta: {
            title: "房间管理",
            index: "Availability",
          }
        },
        {
          path: "/equipment",
          component: () =>
            import("../pages/listingProfile/equipment/index.vue"),
          meta: {
            title: "设备",
            index: "equipment",
          }
        },
        {
          path: "/finance",
          component: () =>
            import("../pages/listingProfile/finance/index.vue"),
          meta: {
            title: "账单",
            index: "finance"
          }
        },
        {
          path: "/platformCollectDetail",
          component: () =>
            import("../pages/listingProfile/finance/platformCollectDetail.vue"),
          meta: {
            title: "对账表",
            index: "platformCollectDetail"
          }
        },
        {
          path: "/wxstoreBalance",
          component: () =>
            import("../pages/listingProfile/finance/subpage/wxstoreBalance.vue"),
          meta: {
            title: "收款金额",
            index: "wxstoreBalance"
          }
        },
        {
          path: "/storeBalance",
          component: () =>
            import("../pages/listingProfile/finance/subpage/storeBalance.vue"),
          meta: {
            // title: "余额",
            title: "余额",
            index: "storeBalance"
          }
        },
        {
          path: "/tlstoreBalance",
          component: () =>
            import("../pages/listingProfile/finance/subpage/tlstoreBalance.vue"),
          // import("../pages/listingProfile/finance/subpage/storeBalance.vue"),
          meta: {
            // title: "余额",
            title: "通联余额",
            index: "tlstoreBalance"
          }
        },
        {
          path: "/storeCardBinding",
          component: () =>
            import("../pages/listingProfile/storeCardBinding/index.vue"),
          meta: {
            title: "营运方账户",
            index: "storeCardBinding"
          }
        },
        {
          path: "/landlordAccount",
          component: () =>
            import("../pages/listingProfile/landlordAccount/index.vue"),
          meta: {
            title: "业主账户",
            index: "landlordAccount"
          }
        },
        {
          path: "/landlordAccountTl",
          component: () =>
            import("../pages/listingProfile/landlordAccountTl/index.vue"),
          meta: {
            title: "业主通联账户",
            index: "landlordAccountTl"
          }
        },
        {
          path: "/addRoomType",
          component: () =>
            import("../pages/listingProfile/addRoomType/index.vue"),
          meta: {
            title: "房型",
            index: "Availability"
          }
        },
        {
          path: "/rentalAgreement",
          component: () =>
            import("../pages/listingProfile/rentalAgreement/index.vue"),
          meta: {
            title: "租约",
            index: "rentalAgreement"
          }
        },
        {
          path: "/list",
          component: () =>
            import("../pages/listingProfile/list/index.vue"),
          meta: {
            title: "报表",
            index: "list"
          }
        },
        {
          path: "/Repair",
          component: () =>
            import("../pages/listingProfile/Repair/index.vue"),
          meta: {
            title: "报修",
            index: "Repair"
          }
        },
        {
          path: "/meterReadingRecord",
          component: () =>
            import("../pages/listingProfile/meterReadingRecord/index.vue"),
          meta: {
            title: "抄表记录",
            index: "meterReadingRecord"
          }
        },
        {
          path: "/centralizedMeterReading",
          component: () =>
            import("../pages/listingProfile/centralizedMeterReading/index.vue"),
          meta: {
            title: "集中抄表",
            index: "centralizedMeterReading"
          }
        },
        {
          path: "/centralizedMeterReadingDaoRu",
          component: () =>
            import("../pages/listingProfile/centralizedMeterReading/centralizedMeterReadingDaoRu.vue"),
          meta: {
            title: "读表数据导入",
            index: "centralizedMeterReadingDaoRu"
          }
        },
        {
          path: "/propertyIinformationImport",
          component: () =>
            import("../pages/listingProfile/PropertyInformationImport/propertyInformationImport.vue"),
          meta: {
            title: "房源数据导入",
            index: "propertyIinformationImport"
          }
        },
        {
          path: "/collectionAudit",
          component: () =>
            import("../pages/listingProfile/financialAudit/Collection/index.vue"),
          meta: {
            title: "收款审核",
            index: "collectionAudit"
          }
        },
        {
          path: "/refundAudit",
          component: () =>
            import("../pages/listingProfile/financialAudit/refund/index.vue"),
          meta: {
            title: "退租审核",
            index: "refundAudit"
          }
        },
        {
          path: "/leaseAudit",
          component: () =>
            import("../pages/listingProfile/financialAudit/lease/index.vue"),
          meta: {
            title: "租约审核",
            index: "leaseAudit"
          }
        },
        {
          path: "/enterpriseAccess",
          component: () =>
            import("../pages/listingProfile/enterpriseAccess/index.vue"),
          meta: {
            title: "企业接入",
            index: "enterpriseAccess"
          }
        },
        {
          path: "/roomSupplement",
          component: () =>
            import("../pages/listingProfile/enterpriseAccess/roomSupplement/index.vue"),
          meta: {
            title: "房间补录",
            index: "enterpriseAccess"
          }
        },
        {
          path: "/leaseSupplement",
          component: () =>
            import("../pages/listingProfile/enterpriseAccess/leaseSupplement/index.vue"),
          meta: {
            title: "租约补录",
            index: "enterpriseAccess"
          }
        },
        {
          path: "/moneySupplement",
          component: () =>
            import("../pages/listingProfile/enterpriseAccess/moneySupplement/index.vue"),
          meta: {
            title: "流水补录",
            index: "moneySupplement"
          }
        },
        {
          path: "/publicConfiguration",
          component: () =>
            import("../pages/listingProfile/publicConfiguration/index.vue"),
          meta: {
            title: "公共配置",
            index: "publicConfiguration"
          }
        },
        {
          path: "/publicMoney",
          component: () =>
            import("../pages/listingProfile/publicMoney/index.vue"),
          meta: {
            title: "费用配置",
            index: "publicMoney"
          }
        },
        {
          path: "/contractDemo",
          component: () =>
            import("../pages/listingProfile/contractDemo/index.vue"),
          meta: {
            title: "合同模板配置",
            index: "contractDemo"
          }
        },
        {
          path: "/addDemo",
          component: () =>
            import("../pages/listingProfile/contractDemo/addDemo.vue"),
          meta: {
            title: "合同模板",
            index: "contractDemo"
          }
        },
        {
          path: "/publiCloss",
          component: () =>
            import("../pages/listingProfile/publiCloss/index.vue"),
          meta: {
            title: "损耗配置",
            index: "publiCloss"
          }
        },
        {
          path: "/apportion",
          component: () =>
            import("../pages/listingProfile/publiCloss/apportion.vue"),
          meta: {
            title: "水电分摊",
            index: "apportion"
          }
        },
        {
          path: "/complain",
          component: () =>
            import("../pages/listingProfile/complain/index.vue"),
          meta: {
            title: "投诉处理",
            index: "complain"
          }
        },
        {
          path: "/landlord",
          component: () =>
            import("../pages/storeManage/landlord/index.vue"),
          meta: {
            title: "业主",
            index: "landlord"
          }
        },
      ]
    }
  ]
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js